// extracted by mini-css-extract-plugin
export default {"top":"ErrorData_top__3QjBk","topContent":"ErrorData_topContent__2qCr6","content":"ErrorData_content__2IekE"};